import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord, query } from '@warp-drive/utilities/json-api';
import type { Store } from '@warp-drive/core';
import type RouterService from '@ember/routing/router';
import type TuitionAssistanceService from 'tio-common/services/tuition-assistance';
import type { TasProgramInstanceExtension as TasProgramInstanceModel } from 'tio-data/data/resources/tas-program-instance.ext';
import type SessionContextService from 'tio-employee/services/session-context';
import type { TasParticipantExtension as TasParticipantModel } from 'tio-data/data/resources/tas-participant.ext';

export default class AuthenticatedTasProgramsShowRoute extends Route {
  @service declare store: Store;
  @service declare router: RouterService;
  @service declare sessionContext: SessionContextService;
  @service declare tuitionAssistance: TuitionAssistanceService;

  includes = [
    'tas-program-template.conditions.public-assets',
    'tas-program-template.company.company-setting',
    'tas-program-template.tas-field-options',
    'tas-applications',
    'tas-applications.tags',
    'tas-applications.tas-courses',
    'dependent',
    'employee.tas-participant',
    'employee.company',
    'employee.dependents',
    'tas-assets.attachments',
  ];

  async model({ tas_program_instance_id }: { tas_program_instance_id: string }) {
    const { content: instanceContent } = (await this.store.request(
      findRecord<TasProgramInstanceModel>('tas-program-instance', tas_program_instance_id, {
        include: this.includes.join(','),
        reload: true,
      })
    )) as { content: { data: TasProgramInstanceModel } };
    const programInstance = instanceContent.data;

    const { content: participantContent } = (await this.store.request(
      query<TasParticipantModel>('tas-participant', {
        'filter[employee]': this.sessionContext.currentEmployee.id,
      })
    )) as { content: { data: TasParticipantModel[] } };

    await this.tuitionAssistance.loadEligibilitiesForCurrentEmployee();

    return { programInstance, tasParticipant: participantContent.data[0] };
  }
}
